(function() {
  'use strict';

  function EventSectionHeaderDirective(Users, Auth, EVENT_STATES) {
    return {
      scope: {
        eventSection: '='
      },
      restrict: 'E',
      templateUrl: 'app/components/events/directives/event-section-header.html',
      link: function(scope) {
        scope.conf = {
          auditLogShown: false
        };

        scope.EVENT_STATES = EVENT_STATES;
        scope.sectionStates = scope.eventSection.getProgress();
        scope.username = Users.remoteUser || Auth.currentUser();

        scope.reloadEvent = function() {
          scope.$emit('EventReload', { id: scope.eventSection.doc._id });
        };
      }
    };
  }

  EventSectionHeaderDirective.$inject = [
    'UsersService',
    'AuthService',
    'EVENT_STATES'
  ];

  angular.module('events.directives')
    .directive('eventSectionHeader', EventSectionHeaderDirective);
})();
